export default __webpack_public_path__ + "static/homepage-buygiftcards-0729388da3919805c4a61ce51203e58c.jpg";